import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZoneCombinationModel } from '../../models';
import { SyncService, ZoningCodeService } from '../../core/services';
import { LoaderService } from '../../../shared/services';
import { filter } from 'rxjs/operators';
import { getCalibrationSetTypeId, TableFieldOption } from '../../../shared/enums';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';
import { IAttributesIdentifiers } from 'src/app/interfaces/attributes-identifiers.interface';

@Component({
    standalone: false,
    selector: 'app-zones-building-typology',
    templateUrl: './zones-building-typology.component.html',
    styleUrls: ['./zones-building-typology.component.scss']

})
export class ZonesBuildingTypologyComponent implements OnInit, OnDestroy {
    @Input()
    currentTab: string;
    subscription = new Subscription();

    selected: string;
    zoningCode: IZoningCodeModel = null;

    private _identifiers: { [property: string]: IAttributesIdentifiers } = {};

    @HostBinding('class')
    readonly hostClass = 'zones-uses';

    get zoneCombinations() {
        if (!this.zoningCode) {
            return;
        }
        return this.zoningCode.ZoneCombinations.sort(ZoneCombinationModel.sortingCalibrationByName);
    }

    constructor(
        private zcService: ZoningCodeService,
        private loaderService: LoaderService,
        private syncService: SyncService,
        private cdr: ChangeDetectorRef
    ) {}

    get calibrationSetType() {
        return getCalibrationSetTypeId(this.currentTab);
    }

    get buildingMandatoryField() {
        return 'BuildingTypologyMandatory';
    }

    get defaultBuildingTypology() {
        return 'DefaultBuildingTypology';
    }

    isAvailable(i: number): boolean {
        return !!this.zoneCombinations[i].BuildingTypologyIds.length;
    }

    ngOnInit() {
        this.loaderService.show();
        this.subscription.add(
            this.zcService.zoningCodes.pipe(filter(zc => zc !== null && zc.length > 0)).subscribe(zc => {
                this.zoningCode = zc[0];
                this.loaderService.hide();
            })
        );
    }

    setValidation(index: number) {
        this.zoneCombinations[index].setValidation();
        this.zoningCode?.clearValidationResults();
        this.syncService.triggerChangeDetection();
        this.cdr.detectChanges();
    }

    private getCalibrationSetTableFieldIdentifier(calibrationId: number, fieldName: string) {
        const key = `${calibrationId}-${fieldName}`;
        if (!this._identifiers[key]) {
            this._identifiers[key] = {
                calibrationSetId: calibrationId,
                calibrationSetType: this.calibrationSetType,
                tableField: { name: fieldName },
                tableFieldOption: TableFieldOption.NONE
            };
        }
        return this._identifiers[key];
    }

    getMandatoryTableFieldIdentifier(calibrationSetId: number) {
        return this.getCalibrationSetTableFieldIdentifier(calibrationSetId, this.buildingMandatoryField);
    }

    getDefaultTableFieldIdentifier(calibrationSetId: number) {
        return this.getCalibrationSetTableFieldIdentifier(calibrationSetId, this.defaultBuildingTypology);
    }

    checkChanges(propertyName: string, index: number) {
        return this.zoneCombinations[index].isFieldChanged(propertyName);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
